import type { ReactNode } from 'react';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { useTitleWhenTruncated } from '../hooks/useTitleWhenTruncated';

const SingleValueRoot = styled.div`
    color: inherit;
    flex: 1;
    font-size: ${theme.fontSizes[14]};
    font-weight: ${theme.fontWeights[400]};
    line-height: 24px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const SingleValue = ({ children, label }: { children: ReactNode; label: string }) => {
    const { ref, title } = useTitleWhenTruncated<HTMLDivElement>(label);

    return (
        <SingleValueRoot ref={ref} title={title}>
            {children}
        </SingleValueRoot>
    );
};
